import ActionTypes from '../../constants/ActionTypes';

// FAMILY-EXT: ошибку создания доски раньше никто не показывал — сага
// откатывала оптимистично добавленную доску, и для пользователя это
// выглядело как "кнопка ничего не делает". Держим последнюю ошибку здесь,
// пикер проект/доска её выводит.
const initialState = {
  error: null,
};

// eslint-disable-next-line default-param-last
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.BOARD_CREATE:
      return {
        ...state,
        error: null,
      };
    case ActionTypes.BOARD_CREATE__SUCCESS:
      return initialState;
    case ActionTypes.BOARD_CREATE__FAILURE:
      return {
        ...state,
        error: payload.error,
      };
    default:
      return state;
  }
};
